<template>
	<div>
		<div class="bg fcc">
			<div class="box">
				<img class="leftbg" src="../assets/loginbg2.png" alt="">
				<div class="rightcon">
					<div class="tabbox fce">
						<div :class="activeName == 'login'?'tab-a':'tab'" @click="activeName = 'login'">登录</div>
						<div :class="activeName == 'register'?'tab-a':'tab'" @click="changenav('/register')">注册</div>
						<div :class="activeName == 'forget'?'tab-a':'tab'" @click="activeName = 'forget'">忘记密码</div>
					</div>
					<div v-if="activeName == 'login'">
						<div class="inputbox fc">
							<div style="width: 80px;">公司名称</div>
							<el-input v-model="loginform.corporate_name" placeholder="请输入公司名称"
								style="width: 250px;"></el-input>
						</div>
						<div class="inputbox fc">
							<div style="width: 80px;">手机号</div>
							<el-input v-model="loginform.account" placeholder="请输入联系人手机号"
								style="width: 250px;"></el-input>
						</div>
						<div class="inputbox fc">
							<div style="width: 80px;">登录密码</div>
							<el-input v-model="loginform.password" placeholder="请输入登录密码" show-password
								style="width: 250px;"></el-input>
						</div>
						<div class="fcc" style="margin-top: 50px;">
							<el-button type="primary" style="width: 300px;" @click="loginbtn">登录</el-button>
						</div>
					</div>
					<div v-if="activeName == 'forget'">
						<div class="inputbox fc">
							<div style="width: 80px;">手机号</div>
							<el-input v-model="forgetform.mobile" placeholder="请输入联系人手机号"
								style="width: 250px;"></el-input>
						</div>
						<div class="inputbox fc">
							<div style="width: 80px;">验证码</div>
							<el-input v-model="forgetform.captcha" placeholder="请输入验证码"
								style="width: 140px;"></el-input>
							<div class="btns" v-if="!disabledCode" @click="obtain">{{codeText}}</div>
							<div class="btns" v-else style="color: #CCC8C8;">{{codeText}}</div>
						</div>
						<div class="inputbox fc">
							<div style="width: 80px;">新密码</div>
							<el-input v-model="forgetform.newpassword" placeholder="请输入新密码" show-password
								style="width: 250px;"></el-input>
						</div>
						<div class="fcc" style="margin-top: 50px;">
							<el-button type="primary" style="width: 300px;" @click="forgetbtn">确定</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeName: 'login',
				loginform: {
					account: '', //账号
					password: '', //密码
					corporate_name: '' //公司名称
				},
				forgetform: {
					mobile: '', //手机号
					captcha: '', //验证码
					newpassword: '' //新密码
				},
				disabledCode: false,
				codeText: '获取验证码',
			}
		},
		created() {

		},
		methods: {
			//登录
			loginbtn() {
				this.$api.home.login(this.loginform).then(res => {
					if (res.code == 1) {
						sessionStorage.setItem('user_info', JSON.stringify(res.data.userinfo));
						sessionStorage.setItem('token', res.data.userinfo.token);
						this.$message({
							message: '恭喜你，登录成功',
							type: 'success'
						});
						setTimeout(() => {
							this.$router.push({
								path: '/'
							})
							sessionStorage.setItem('pagepath', '/')
						}, 1500)
					}
				})
			},
			//切换导航
			changenav(path) {
				this.path = path;
				this.$router.push({
					path: path
				})
				sessionStorage.setItem('pagepath', path)
			},
			//忘记密码
			forgetbtn() {
				this.$api.home.resetpwd(this.forgetform).then(res => {
					if (res.code == 1) {
						this.$message({
							message: '恭喜你，修改成功',
							type: 'success'
						});
						this.activeName = 'login'
						this.disabledCode = false;
					}
				})
			},
			//获取验证码
			obtain() {
				let that = this;
				if (that.forgetform.mobile == '') {
					alert('请先输入手机号')
					return;
				}
				let data = {
					mobile: that.forgetform.mobile,
					event: 'resetpwd'
				}
				this.$api.home.send(data).then(res => {
					if (res.code == 1) {
						that.disabledCode = true;
						this.$message({
							message: '发送成功',
							type: 'success'
						});
						var time = 60;
						var timer = setInterval(fun, 1000);

						function fun() {
							time--;
							if (time >= 0) {
								that.codeText = time + "秒重新发送";
							} else if (time < 0) {
								that.codeText = "获取验证码";
								that.disabledCode = false;
								clearInterval(timer);
								time = 60;
							}
						}
					}
				})
			}
		}
	}
</script>

<style scoped>
	.bg {
		width: 100%;
		height: 100vh;
		background: url("../assets/loginbg.jpg");
		background-size: cover;
		background-position: center center;
	}

	.box {
		width: 950px;
		min-height: 500px;
		background: #ffffff;
		border-radius: 10px;
		position: relative;
		overflow: hidden;
	}

	.leftbg {
		width: 500px;
		position: absolute;
		top: 0;
		left: 0;
	}

	.rightcon {
		width: 400px;
		position: absolute;
		top: 60px;
		right: 30px;
	}

	.tabbox {
		font-size: 22px;
		margin-bottom: 40px;
	}

	.tabbox .tab {
		padding-bottom: 4px;
		border-bottom: #ffffff solid 5px;
		cursor: pointer;
	}

	.tabbox .tab-a {
		padding-bottom: 4px;
		border-bottom: #409EFF solid 4px;
		cursor: pointer;
	}

	.inputbox {
		width: 340px;
		margin: 0 auto;
		margin-top: 20px;
	}

	.btns {
		margin-left: 10px;
		font-size: 14px;
		color: #409EFF;
		cursor: pointer;
	}
</style>